/**
 * The head of "Nowe wydarzenie" / "Nowe wypożyczenie" in the side panel (owner 2026-10-21 23:31): the title and, like
 * the event card, "Pełny widok" / "Zmniejsz" (not on a phone, where the panel covers the screen) and "Zamknij".
 */
export function NewPanelHead({ title, full, onFullChange, phone, onClose }: { title: string; full: boolean; onFullChange?: ((full: boolean) => void) | undefined; phone: boolean; onClose: () => void }) {
  return (
    <div className="event-card-head">
      <div className="event-card-title">
        <h2 tabIndex={-1}>{title}</h2>
      </div>
      <div className="event-card-tools">
        {onFullChange && !phone && (
          <button className="btn ghost small" type="button" onClick={() => onFullChange(!full)}>
            {full ? 'Zmniejsz' : 'Pełny widok'}
          </button>
        )}
        <button className="btn ghost small" type="button" onClick={onClose}>
          Zamknij
        </button>
      </div>
    </div>
  );
}
